module.exports = __webpack_public_path__ + "img/003c3135-25aa-48ca-810b-925ca2bf4d46.001.85e8921f.png";